module.exports = __webpack_public_path__ + "static/media/menu_white.8f1633a5.svg";